import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/VerifiedLocations/VerifiedLocations.js
const VerifiedLocations = createSectionForm({
  icon: "map-pin-2-line",
  title: "Verified Locations Map",
  fields: [
    { name: "title", label: "Title" },
    { name: "count_label", label: "Count Label", placeholder: "Verified Installer:" },
    { name: "description", label: "Description", type: "richtext" },
    {
      name: "locations",
      label: "Installers",
      type: "list",
      itemLabel: "Installer",
      fields: [
        { name: "title", label: "Name" },
        { name: "address", label: "Address" },
        { name: "phone", label: "Phone" },
        { name: "email", label: "Email" },
        { name: "website", label: "Website" },
        { name: "lat", label: "Latitude", type: "number" },
        { name: "lng", label: "Longitude", type: "number" },
      ],
    },
  ],
});

export default VerifiedLocations;
